import { forwardRef } from "react";

// Elegant line-art brain-with-leaf emblem — echoes Tacilaine's original post logo.
export const BrandMark = forwardRef(function BrandMark(
  { className = "", color = "#5B6E5B", stroke = 1.4 },
  ref
) {
  return (
    <svg
      ref={ref}
      viewBox="0 0 64 64"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <circle cx="32" cy="32" r="30.2" stroke={color} strokeWidth={stroke * 0.7} opacity="0.4" />
      {/* left hemisphere */}
      <path
        d="M31 21.5c-3.2-3-8.3-2.4-10.4 1-2.9-.6-5.6 1.6-5.6 4.6 0 .8.2 1.5.5 2.1-1.8 1.1-2.6 3.4-1.7 5.4-1.3 1.4-1.5 3.6-.3 5.2 1.2 1.6 3.3 2.1 5 1.4 1.1 2.1 3.6 3 5.8 2.1 1.4 1.6 3.7 2 5.6 1.1"
        stroke={color}
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* right hemisphere */}
      <path
        d="M33 21.5c1.9-1.8 4.6-2 6.7-.7"
        stroke={color}
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* central stem */}
      <path d="M32 20.5v24" stroke={color} strokeWidth={stroke} strokeLinecap="round" />
      {/* sprouting leaf */}
      <path
        d="M40 22c4.5-1.2 8.7 1 10 4.8-4.3 1.4-8.7-.6-10-4.8Z"
        stroke={color}
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M40 22c2.4.9 4.5 2.4 6.3 4.4" stroke={color} strokeWidth={stroke * 0.8} strokeLinecap="round" />
    </svg>
  );
});

// Delicate fern branch — used as faint parallax background decoration.
export function Fern({ className = "", color = "#5B6E5B", opacity = 0.14 }) {
  const leaflets = Array.from({ length: 11 });
  return (
    <svg viewBox="0 0 160 420" fill="none" className={className} style={{ opacity }} aria-hidden="true">
      <path
        d="M80 415C80 340 74 250 96 175C112 118 120 70 116 12"
        stroke={color}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      {leaflets.map((_, i) => {
        const t = i / (leaflets.length - 1);
        const y = 400 - t * 380;
        const x = 80 + Math.sin(t * Math.PI) * 14 + t * 22;
        const len = 34 - t * 22;
        const side = i % 2 === 0 ? 1 : -1;
        return (
          <g key={i}>
            <path
              d={`M${x} ${y} q ${side * len * 0.6} ${-len * 0.5} ${side * len} ${-len * 0.9}`}
              stroke={color}
              strokeWidth="1.1"
              strokeLinecap="round"
            />
            <path
              d={`M${x} ${y} q ${side * len * 0.5} ${-len * 0.7} ${side * len * 0.85} ${-len * 1.15}`}
              stroke={color}
              strokeWidth="0.8"
              strokeLinecap="round"
              opacity="0.7"
            />
          </g>
        );
      })}
    </svg>
  );
}

// Small eucalyptus sprig — inline separator accent.
export function Sprig({ className = "", color = "#C87A5E" }) {
  const pairs = Array.from({ length: 5 });
  return (
    <svg viewBox="0 0 90 30" fill="none" className={className} aria-hidden="true">
      <path d="M4 15 H80" stroke={color} strokeWidth="1.1" strokeLinecap="round" />
      {pairs.map((_, i) => {
        const x = 16 + i * 14;
        return (
          <g key={i}>
            <ellipse cx={x} cy="9" rx="5.5" ry="3" transform={`rotate(-30 ${x} 9)`} stroke={color} strokeWidth="1" />
            <ellipse cx={x} cy="21" rx="5.5" ry="3" transform={`rotate(30 ${x} 21)`} stroke={color} strokeWidth="1" />
          </g>
        );
      })}
      <circle cx="84" cy="15" r="2" fill={color} />
    </svg>
  );
}
